import { render, staticRenderFns } from "./TripDetailTabDetails.vue?vue&type=template&id=04cd20c0&"
import script from "./TripDetailTabDetails.vue?vue&type=script&lang=ts&"
export * from "./TripDetailTabDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports